import { inject, Injectable } from "@angular/core";
import { ApiPosService } from "./api.pos.service";
import { AppContext } from "./app-context.service";
import { LoginService } from "./login.service";
import { HttpMethod } from "./model/http-method.enum";
import { AliveResponse, ILocalizationLanguage } from "./model/pos.api.model";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CreateFinancialTransactionRequest, TransferTransactionRequest, TransferTransactionResult } from "./model/create-financial-transaction.model";
import { CreateFinancialTransactionResponse } from "./model/create-financial-transaction-response.model";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, lastValueFrom, map, Observable, of } from "rxjs";
import { CURRENT_BUILD_KEY } from "./build-version";

//import {
//  ErrorDialogComponent,
//  IErrorDialogData,
//} from "src/components/mobile/ui-components/mobile/dialogs/error-dialog/error-dialog.component";
//import { AddItemResult } from "src/components/mobile/transaction/item-model";

@Injectable({
  providedIn: "root",
})
export class PosDataService {
    private urlBase: string = `${environment.apiAddress}/apiServer/pos`;
    private DefTimeout = '30000';
    private http = inject(HttpClient);
    private headers = new HttpHeaders({
        "Country-Code": "cs-CZ",
    });


    constructor() 
    {
    }

  public async createFinancialTransaction(request: CreateFinancialTransactionRequest): Promise<CreateFinancialTransactionResponse | null> {
    
        const financialTransactionUrl = `${environment.apiAddress}/api/dert/CreateFinancialTransaction`;
        console.log('financial transaction url is, ', financialTransactionUrl);
        console.log('request is, ', request);
        const response = await lastValueFrom(
            this.http.post<CreateFinancialTransactionResponse>(financialTransactionUrl, request, {
                headers: this.headers,
            }).pipe(
              catchError((error) => {
                console.error("Error creating financial transaction:", error);
                return of(null);
              }),
            ),
        );
        return response;
  }

  public createTransferTransaction(request: TransferTransactionRequest): Observable<TransferTransactionResult> {
    const url = `${environment.apiAddress}/api/dert/CreateTransferTransaction`;
    console.log('createTransferTransaction url:', url);
    console.log('createTransferTransaction request:', request);
    return this.http.post<TransferTransactionResult>(url, request, { headers: this.headers });
  }

  public async createMultiFinancialTransactions(request: CreateFinancialTransactionRequest[]): Promise<CreateFinancialTransactionResponse[] | null> {
    const url = `${environment.apiAddress}/api/dert/CreateMultiFinancialTransactions`;
    console.log('createMultiFinancialTransactions url:', url);
    console.log('createMultiFinancialTransactions request:', request);

    const response = await lastValueFrom(
      this.http.post<CreateFinancialTransactionResponse[]>(url, request, {
        headers: this.headers,
      }).pipe(
        catchError((error) => {
          console.error("Error creating multiple financial transactions:", error);
          return of(null);
        }),
      ),
    );

    return response;
  }

  async getAvailableLanguages(): Promise<ILocalizationLanguage[]> {
    return lastValueFrom(
      this.http.get<{ languages: ILocalizationLanguage[] }>(`/assets/i18n/languages.json`, {
        params: { version: CURRENT_BUILD_KEY },
      }).pipe(
        map(response => response.languages),
        catchError((error) => {
          console.error("Error loading available languages:", error);
          return of([{ code: "cs", label: "Čeština" }]);
        }),
      ),
    );
  }

  async getSelectedLanguage(language: string): Promise<any> {
    return lastValueFrom(
      this.http.get<any>(`/assets/i18n/${language}.json`, {
        params: { version: CURRENT_BUILD_KEY },
      }).pipe(
        catchError((error) => {
          console.error(`Error loading language '${language}':`, error);
          return of(undefined);
        }),
      ),
    );
  }

}
